document.addEventListener('DOMContentLoaded', () => {
    const toggles = document.querySelectorAll('.section-collapse__item-toggle');
    const imageWrapper = document.querySelector('.section-collapse__image-wrapper');

    function updateImage(imageUrl, altText) {
        if (imageWrapper) {
            if (imageUrl) {
                // Si ya existe una imagen, actualizar su src
                let img = imageWrapper.querySelector('img');
                if (!img) {
                    // Si no existe la imagen, crearla
                    img = document.createElement('img');
                    img.className = 'section-collapse__image';
                    // Remover el placeholder si existe
                    const placeholder = imageWrapper.querySelector('.section-collapse__image-placeholder');
                    if (placeholder) {
                        placeholder.remove();
                    }
                    imageWrapper.appendChild(img);
                }
                img.src = imageUrl;
                img.alt = altText || '';
            }
        }
    }

    toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            const content = toggle.nextElementSibling;
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            const item = toggle.closest('.section-collapse__item');
            const imageUrl = item.dataset.image;

            // Cerrar todos los otros collapses
            toggles.forEach(otherToggle => {
                if (otherToggle !== toggle && otherToggle.getAttribute('aria-expanded') === 'true') {
                    const otherContent = otherToggle.nextElementSibling;
                    otherToggle.setAttribute('aria-expanded', 'false');
                    otherToggle.parentElement.classList.remove('section-collapse__item--active');
                    otherContent.style.maxHeight = '0';
                    otherContent.style.opacity = '0';
                    otherContent.style.paddingBottom = '0';
                    otherContent.style.transition = 'max-height 0.5s ease-in-out, opacity 0.5s ease-in-out, padding-bottom 0.5s ease-in-out';
                }
            });

            // Abrir/cerrar el collapse actual
            toggle.setAttribute('aria-expanded', !isExpanded);
            toggle.parentElement.classList.toggle('section-collapse__item--active');

            if (isExpanded) {
                content.style.maxHeight = '0';
                content.style.opacity = '0';
                content.style.paddingBottom = '0';
                content.style.transition = 'max-height 0.5s ease-in-out, opacity 0.5s ease-in-out, padding-bottom 0.5s ease-in-out';
            } else {
                content.style.maxHeight = `${content.scrollHeight}px`;
                content.style.opacity = '1';
                content.style.paddingBottom = '20px';
                content.style.transition = 'max-height 0.5s ease-in-out, opacity 0.5s ease-in-out, padding-bottom 0.5s ease-in-out';
                // Actualizar la imagen cuando se abre el collapse
                updateImage(imageUrl, toggle.textContent.trim());
            }
        });
    });

    // Mostrar la imagen del primer item por defecto
    const firstItem = document.querySelector('.section-collapse__item');
    if (firstItem) {
        const firstImageUrl = firstItem.dataset.image;
        const firstTitle = firstItem.querySelector('.section-collapse__item-toggle').textContent.trim();
        updateImage(firstImageUrl, firstTitle);
    }
});